export default {
  'environments.title': 'Gestionar Entornos',
  'environments.type.development': 'Desarrollo',
  'environments.type.testing': 'Pruebas',
  'environments.type.production': 'Producción',
};
